module.exports = __webpack_public_path__ + "static/media/client1.0378ba67.svg";